type TProps = {
  className?: string;
};

export const QuotesIcon = ({ className }: TProps) => (
  <svg
    fill="none"
    height="17"
    viewBox="0 0 19 17"
    width="19"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className={className}
      d="M10.8123 13.2634C10.8123 12.4559 10.9597 11.691 11.2544 10.9686L14.7913 0.578125H18.3281L15.0439 10.4586C16.6018 10.8411 17.3808 11.8185 17.3808 13.3909C17.3808 14.3258 17.065 15.0907 16.4334 15.6857C15.8439 16.2806 15.1071 16.5781 14.2229 16.5781C13.2544 16.5781 12.4334 16.2594 11.7597 15.6219C11.1281 14.9845 10.8123 14.1983 10.8123 13.2634ZM0.328125 13.2634C0.328125 12.4559 0.475493 11.691 0.77023 10.9686L4.30707 0.578125H7.84392L4.5597 10.4586C6.1176 10.8411 6.89655 11.8185 6.89655 13.3909C6.89655 14.3258 6.58076 15.0907 5.94918 15.6857C5.35971 16.2806 4.62286 16.5781 3.73865 16.5781C2.77023 16.5781 1.94918 16.2594 1.27549 15.6219C0.643915 14.9845 0.328125 14.1983 0.328125 13.2634Z"
      fill="#FFB71C"
    />
  </svg>
);
